import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Paper,
    Skeleton,
    styled,
    Typography,
} from '@mui/material';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addBooking } from '../../redux/BookingSlice';
import { getSchoolTeachers } from '../../redux/SchoolSlice';
import GradeDropDown from '../CustomDropDown/GradeDropDown';
import TeacherMultiDropDown from '../CustomDropDown/TeacherMultiDropDown';
import TimeDropDown from '../CustomDropDown/TimeDropDown';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px 10px',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

/*
 * CrtAvailability - Shows availability of teacher
 * @param {string} props.searchDate - date searched for
 * @param {string} props.id - avail uniqueId
 * @param {bool} props.reduced - reduced view (unsaved)
 */

const CrtAvailability = props => {
    const { getAccessTokenSilently } = useAuth0();

    const [availability, setAvailability] = useState();
    const [loadingState, setLoadingState] = useState('Not Started');
    const [state, setState] = useState({
        teachersInSchool: {
            value: [],
            error: '',
            errorCode: '',
        },
        grade: [],
        processingBooking: 0,
        bookingResponse: '',
    });
    const [selected, setSelected] = useState();

    const [timeError, setTimeError] = useState(false);
    const [outsideDialog, setOutsideDialog] = useState(false);

    const reduced = props.reduced !== undefined ? true : false;

    const dispatch = useDispatch();
    async function getAvailability(userId, sDate, eDate) {
        try {
            setLoadingState('loading');

            const newToken = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let response = await axios.post(
                '/getCrtAvailability',
                {
                    id: userId,
                    startDate: format(sDate, 'yyyy-MM-dd'),
                    endDate: format(eDate, 'yyyy-MM-dd'),
                },
                {
                    baseURL: process.env.REACT_APP_API_GATEWAY,
                    url: `/getCrtAvailability`,
                    timeout: 30000,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + newToken,
                    },
                }
            );
            console.log('availabiltiy response', response.data);
            setAvailability(response.data.availability.Message);
            setLoadingState('loaded');
        } catch (err) {
            console.log('Err', err);
            setLoadingState('failed');
        }
    }

    useEffect(() => {
        const startMoment = moment(state.startTime, 'h:mm a');
        const endMoment = moment(state.endTime, 'h:mm a');
        setTimeError(startMoment >= endMoment);
    }, [state.startTime, state.endTime]);
    
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    useEffect(() => {
        if (typeof props.id !== 'undefined') {
            let start =
                props.searchDate !== undefined
                    ? new Date(props.searchDate)
                    : new Date();
            let end = new Date();
            if (props.reduced) end = addDays(start, 7);
            else end = addDays(start, 30);
            getAvailability(props.id, start, end);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.id]);

    const outsideAvailabilityCheck = () => {
        setOutsideDialog(true);
    };

    const handleCloseDialog = () => {
        setOutsideDialog(false);
    };

    const processBooking = async (pk1, sk1, uniqueId) => {
        try {
            setState({
                ...state,
                processingBooking: 4,
            });
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            let requestData = {};

            if (props.school.teachersInSchool.Data.length === 0) {
                requestData = {
                    token: token,
                    request: {
                        availabilityId: pk1,
                        availabilityRef: sk1,
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                    },
                };
            } else {
                let fillInTeachers = props.school.teachersInSchool.Data.filter(
                    teacher =>
                        state.teachersInSchool.value.indexOf(teacher.uniqueId) >
                        -1
                );
                requestData = {
                    token: token,
                    request: {
                        availabilityId: pk1,
                        availabilityRef: sk1,
                        teacherId: fillInTeachers,
                        startTime: state.startTime,
                        endTime: state.endTime,
                        grade: state.grade,
                    },
                };
            }
            const bookingOutcome = await dispatch(addBooking(requestData));
            console.log('bookingoutcome', bookingOutcome);
            if (typeof bookingOutcome.error !== 'undefined') {
                if (
                    bookingOutcome.error.message ===
                    'Request failed with status code 402'
                ) {
                    setState({
                        ...state,
                        processingBooking: 3,
                        apiMessage: 'Error occurred creating booking',
                    });

                    props.setNotif(
                        'error',
                        0,
                        'Booking credits are depleated. Change your subscription for unlimited bookings.'
                    );
                } else {
                    setState({
                        ...state,
                        processingBooking: 3,
                        apiMessage: 'Error occurred creating booking',
                    });

                    props.setNotif('error', 0, 'Creating the Booking Failed');
                }
            } else {
                if (bookingOutcome.payload.status === 200) {
                    let tempAvailabilities = availability.Data;
                    tempAvailabilities.map(avail => {
                        if (avail.uniqueId === uniqueId) {
                            avail.status = 'On Hold';
                            return avail;
                        } else {
                            return avail;
                        }
                    });
                    props.setNotif('success', 6000, 'Booking Successful');
                    // props.notification({
                    //     message: 'Booking Successful',
                    //     open: true,
                    //     severity: 'success',
                    // });
                    setAvailability({
                        ...availability,
                        Data: tempAvailabilities,
                    });
                    setState({
                        ...state,
                        processingBooking: 1,
                    });
                    setSelected();
                } else {
                    setState({
                        ...state,
                        processingBooking: 3,
                        apiMessage: 'Error occurred creating booking',
                    });

                    props.setNotif('error', 0, 'Creating the Booking Failed');
                    // props.notification({
                    //     message: 'Creating the Booking Failed',
                    //     open: true,
                    //     severity: 'error',
                    // });
                }
            }
        } catch (err) {
            console.log('Error occurred adding booking', err);
            setState({
                ...state,
                processingBooking: 3,
                apiMessage: 'Error occurred creating booking',
            });

            props.setNotif('error', 0, 'Creating the Booking Failed');
            // props.notification({
            //     message: 'Creating the Booking Failed',
            //     open: true,
            //     severity: 'error',
            // });
        }
    };

    const handleStartTimeChange = event => {
        setState({
            ...state,
            startTime: event.target.value,
        });
    };

    const handleEndTimeChange = event => {
        setState({
            ...state,
            endTime: event.target.value,
        });
    };

    const handleGradeChange = value => {
        setState({
            ...state,
            grade: value,
        });
    };

    const handleSelect = value => {
        var itemStruct = {
            value: value,
            touched: true,
        };
        setState({
            ...state,
            teachersInSchool: itemStruct,
        });
    };

    const selectAvailability = avail => {
        if (typeof avail.uniqueId !== 'undefined') {
            setSelected(avail.uniqueId);
            var starterTime = format(parseISO(avail.startDate), 'h:mm aaa');
            var enderTime = format(parseISO(avail.endDate), 'h:mm aaa');

            setState({
                ...state,
                startTime: starterTime,
                endTime: enderTime,
                earliestTime: starterTime,
                latestTime: enderTime,
            });
        }
    };

    const unselectAvailability = avail => {
        setSelected();
        setState({
            ...state,
            startTime: undefined,
            endTime: undefined,
            earliestTime: undefined,
            latestTime: undefined,
        });
    };

    useEffect(() => {
        if (props.school?.getTeacherStatus === 'idle') {
            async function dispatchSchoolTeachersFromStore() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                const requestData = {
                    'token': token,
                };

                //doesnt seem to work on Safari - need to troubleshoot
                dispatch(getSchoolTeachers(requestData));
            }
            dispatchSchoolTeachersFromStore();
        }
        console.log('school info', JSON.stringify(props.school));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.school?.getTeacherStatus, props.school?.teachersInSchool?.Data]);

    return (
        <Box sx={{ marginBottom: '30px', width: '100%' }}>
            <Typography variant="h4">Availability</Typography>
            {loadingState === 'loading' && (
                <Box
                    sx={{
                        margin: '30px 0px',
                    }}
                >
                    <Skeleton animation="wave" height={150} />
                </Box>
            )}
            {loadingState === 'loaded' && (
                <Grid container sx={{}}>
                    {availability.Data.map(avail => {
                        return (
                            <Grid
                                item
                                sx={{ padding: '10px' }}
                                xs={12}
                                sm={selected === avail.uniqueId ? 12 : 6}
                                md={selected === avail.uniqueId ? 12 : 4}
                            >
                                <Grid
                                    container
                                    data-cy="avail-card"
                                    sx={{
                                        padding: '10px 20px',
                                        borderRadius: '12px',
                                        boxShadow: '2px 2px 8px 0 #b3bac7',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={reduced ? 12 : 6}
                                        sx={{ width: '100%' }}
                                    >
                                        <Grid container alignItems="center">
                                            <Grid item xs={reduced ? 4 : 12}>
                                                <Typography
                                                    variant="h6"
                                                    data-cy="avail-date"
                                                >
                                                    {format(
                                                        parseISO(
                                                            avail.startDate
                                                        ),
                                                        'dd MMM yyyy'
                                                    )}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={reduced ? 4 : 12}>
                                                <Typography data-cy="avail-times">
                                                    {format(
                                                        parseISO(
                                                            avail.startDate
                                                        ),
                                                        'h:mm aaa'
                                                    )}
                                                    {' - '}
                                                    {format(
                                                        parseISO(avail.endDate),
                                                        'h:mm aaa'
                                                    )}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={reduced ? 4 : 12}>
                                                <Chip
                                                    data-cy="avail-status"
                                                    label={avail.status}
                                                    sx={{ margin: '10px' }}
                                                    color={
                                                        avail.status ===
                                                        'Available'
                                                            ? 'success'
                                                            : 'secondary'
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        {avail.status === 'Available' &&
                                            !selected &&
                                            !reduced && (
                                                <BookingButton
                                                    data-cy="book-now"
                                                    variant="outlined"
                                                    onClick={() => {
                                                        selectAvailability(
                                                            avail
                                                        );
                                                    }}
                                                >
                                                    Book Now
                                                </BookingButton>
                                            )}
                                    </Grid>
                                    {!reduced && (
                                        <Accordion
                                            expanded={
                                                selected === avail.uniqueId &&
                                                avail.status === 'Available'
                                            }
                                            sx={{
                                                boxShadow: 'none',
                                                position: 'inherit',
                                                width: '100%',
                                            }}
                                        >
                                            <AccordionSummary
                                                sx={{
                                                    boxShadow: 'none',
                                                    display: 'none',
                                                }}
                                            ></AccordionSummary>
                                            <AccordionDetails
                                                sx={{
                                                    width: '100%',
                                                }}
                                            >
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            lg={4}
                                                            xl={3}
                                                        >
                                                            <TimeDropDown
                                                                id="startTime"
                                                                title="Start Time"
                                                                defaultTime={
                                                                    state.startTime
                                                                }
                                                                handleTimeChange={
                                                                    handleStartTimeChange
                                                                }
                                                                error={
                                                                    timeError
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            lg={4}
                                                            xl={3}
                                                        >
                                                            <TimeDropDown
                                                                id="endTime"
                                                                title="End Time"
                                                                defaultTime={
                                                                    state.endTime
                                                                }
                                                                handleTimeChange={
                                                                    handleEndTimeChange
                                                                }
                                                                error={
                                                                    timeError
                                                                }
                                                                errorText={
                                                                    'Times are invalid'
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            lg={4}
                                                            xl={3}
                                                        >
                                                            <GradeDropDown
                                                                title="Grade"
                                                                subtitle="Select grade level"
                                                                grade={
                                                                    state.grade
                                                                }
                                                                schoolGrades={
                                                                    avail.grades
                                                                }
                                                                handleGrade={
                                                                    handleGradeChange
                                                                }
                                                            />
                                                        </Grid>

                                                        {typeof props.school
                                                            ?.teachersInSchool
                                                            ?.Data ===
                                                        'undefined' ? (
                                                            <div></div>
                                                        ) : (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                md={6}
                                                                lg={4}
                                                                xl={3}
                                                            >
                                                                <TeacherMultiDropDown
                                                                    id="teacherInSchool"
                                                                    selectedTeachers={
                                                                        state
                                                                            .teachersInSchool
                                                                            .value
                                                                    }
                                                                    teachers={
                                                                        props
                                                                            .school
                                                                            .teachersInSchool
                                                                            .Data
                                                                    }
                                                                    handleSelect={
                                                                        handleSelect
                                                                    }
                                                                    subtitle="Select Replacement Teacher"
                                                                    title="Classroom Teacher (OPTIONAL):"
                                                                    compareValue="pk1"
                                                                    loadingStatus={
                                                                        props
                                                                            .school
                                                                            .getTeacherStatus
                                                                    }
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>

                                                    {state.processingBooking ===
                                                    '3' ? (
                                                        <BookingButton
                                                            variant="outlined"
                                                            color="error"
                                                            disabled
                                                        >
                                                            Failed
                                                        </BookingButton>
                                                    ) : (
                                                        <div>
                                                            <BookingButton
                                                                variant="outlined"
                                                                onClick={() => {
                                                                    if (
                                                                        moment(
                                                                            state.startTime,
                                                                            'h:mm a'
                                                                        ) <
                                                                            moment(
                                                                                state.earliestTime,
                                                                                'h:mm a'
                                                                            ) ||
                                                                        moment(
                                                                            state.endTime,
                                                                            'h:mm a'
                                                                        ) >
                                                                            moment(
                                                                                state.latestTime,
                                                                                'h:mm a'
                                                                            )
                                                                    ) {
                                                                        outsideAvailabilityCheck();
                                                                    } else {
                                                                        processBooking(
                                                                            avail.pk1,
                                                                            avail.sk1,
                                                                            avail.uniqueId
                                                                        );
                                                                    }
                                                                }}
                                                                loadingPosition="start"
                                                                startIcon={
                                                                    <SaveIcon />
                                                                }
                                                                loading={
                                                                    state.processingBooking ===
                                                                    4
                                                                }
                                                                disabled={
                                                                    timeError
                                                                }
                                                            >
                                                                Submit
                                                            </BookingButton>
                                                            <BookingButton
                                                                variant="outlined"
                                                                onClick={
                                                                    unselectAvailability
                                                                }
                                                                loadingPosition="start"
                                                                startIcon={
                                                                    <SaveIcon />
                                                                }
                                                            >
                                                                Cancel
                                                            </BookingButton>

                                                            <Dialog
                                                                open={
                                                                    outsideDialog
                                                                }
                                                                onClose={
                                                                    handleCloseDialog
                                                                }
                                                            >
                                                                <DialogTitle id="alert-dialog-title">
                                                                    {
                                                                        'Are you sure?'
                                                                    }
                                                                </DialogTitle>
                                                                <DialogContent>
                                                                    <DialogContentText id="alert-dialog-description">
                                                                        You have
                                                                        requested
                                                                        for
                                                                        booking
                                                                        times
                                                                        outside
                                                                        the
                                                                        teacher's
                                                                        availability!
                                                                        This
                                                                        will
                                                                        likely
                                                                        result
                                                                        in a
                                                                        declined
                                                                        booking.
                                                                        Continue?
                                                                    </DialogContentText>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                    <Button
                                                                        onClick={
                                                                            handleCloseDialog
                                                                        }
                                                                    >
                                                                        Disagree
                                                                    </Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            handleCloseDialog();
                                                                            processBooking(
                                                                                avail.pk1,
                                                                                avail.sk1,
                                                                                avail.uniqueId
                                                                            );
                                                                        }}
                                                                    >
                                                                        Agree
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </div>
                                                    )}
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    )}
                                </Grid>
                            </Grid>
                        );
                    })}
                    {availability.Data.length === 0 && (
                        <Paper sx={{ padding: '30px 20px', width: '100%' }}>
                            <Typography variant="h6">
                                This teacher has no available dates within
                                {reduced ? ' 7 ' : ' 30 '} days
                                {props.searchDate !== undefined
                                    ? ' of searched date'
                                    : ''}
                            </Typography>
                        </Paper>
                    )}
                </Grid>
            )}
        </Box>
    );
};

export default CrtAvailability;
